import React, { useState, useMemo, useEffect, useRef, useCallback, useContext } from 'react';
import {
    Box,
    Checkbox,
    FormControlLabel,
    Menu,
    MenuItem,
    Button,
    Typography,
    Divider,
    Paper,
    Snackbar,
    Alert,
    Tooltip
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from "@mui/material";
import { WATCHLIST_CONTAINER_WIDTH, CHART_SCREEN_TYPE, CHART_COLORS, VA_TYPE, WATCHLIST_MIN_WIDTH, WATCHLIST_MAX_WIDTH } from '../../../common/utility/mp_chart_constants';
import WatchlistDropdownComponent from '../../../components/AppHeader/WatchlistDropdownComponent';
import WatchlistSymbolModal from '../../../components/AppHeader/WatchlistInstrumentModal';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../../common/api/urls';
import { transformAndReverseMap } from '../../../common/utility/helperFunc';
import { MP_CHART_RELOAD_TIME, NOTIFICATION_POLLING_INTERVAL, TEXT_MSGS, USER_RESOURCES_LIST, USER_ROLE_FIELDS, WATCHLIST_POLLING_INTERVAL, WATCHLIST_TABLE_SETTINGS_KEY } from '../../../common/utility/constant';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../common/hooks/useAuth';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { UserSettingsContext } from '../../../setup/routes-manager/RequireAuth';



const defaultSortModel = [];

const Watchlist = (props) => {
    const theme = useTheme();
    const [width, setWidth] = useState(WATCHLIST_CONTAINER_WIDTH);
    const isResizing = useRef(false);
    const startX = useRef(0);
    const startWidth = useRef(0);

    // const [selectedCols, setSelectedCols] = useState( allColumns.map((col) => col.field));
    const [selectedCols, setSelectedCols] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dividerY, setDividerY] = useState(400);
    const [dragging, setDragging] = useState(false);
    const [instrumentModal, setInstrumentModal] = useState(false);
    const [cancelUIData, responseDataUIData, errorUIData, loadedUIData, resetUIData, executeAPIUIData] = useAxiosWithAuth();
    const [cancelCreate, responseDataCreate, errorCreate, loadedCreate, resetCreate, executeAPICreate] = useAxiosWithAuth();
    const [cancel, responseData, error, loaded, reset, executeAPI] = useAxiosWithAuth();
    const [selectedWatchList, setSelectedWatchlist] = useState();
    const [selectedWatchListInstrument, setSelectedWatchlistInstrument] = useState();
    const [instrumentData, setInstrumentData] = useState([]);
    const [dragStartY, setDragStartY] = useState(null);
    const [startDividerY, setStartDividerY] = useState(null);
    const [columnList, setColumnList] = useState([]);
    const [tableData, setTableData] = useState([]);
    // Symbol that needs navigation after UIDATA adds it
    const [pendingSymbol, setPendingSymbol] = useState(null);
    const { auth } = useAuth();
    const [state, setState] = useState({
        isLoading: true,
        isInstrumentLive: false,
        lastLoadTime: -1,
        refreshInterval: -1,
        isPollingAllowed: false,
        isTradingSessionActive: false,
        reloadInerval: (auth.role.find(el => el == USER_ROLE_FIELDS.FAST_DATA)) ? (auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED) ? MP_CHART_RELOAD_TIME.FAST_DATA : MP_CHART_RELOAD_TIME.MINWISE_DATA) : (MP_CHART_RELOAD_TIME.SLOW_DATA),
        pollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,

    })
    const { isLoading, isInstrumentLive, lastLoadTime, reloadInerval, pollingInterval, refreshInterval, isPollingAllowed, isTradingSessionActive } = state;
    const stateRef = useRef(state);
    const navigate = useNavigate();
    const from = "/login";
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const { userSettings, setUserSettings } = useContext(UserSettingsContext);
    const [sortModel, setSortModel] = useState(defaultSortModel);
    const [dataTypeContracts, setDataTypeContracts] = useState(userSettings.data.data_in_contracts);


    useEffect(() => {
        console.log("userSettings changed =", userSettings.data.data_in_contracts);
        if (dataTypeContracts != userSettings.data.data_in_contracts) {
            setDataTypeContracts(userSettings.data.data_in_contracts)
            executeAPI(`${URL.GET_WATCHLIST}?name=${selectedWatchList}&mdata=1`, "GET", { mdata: 1, selectedWatchList })
        }
    }, [userSettings])
    // const [isLoading, setIsLoading] = useState(true);
    const [msgState, setMsgState] = useState({
        openSnack: false,
        msg: '',
        severity: 'info',
    })
    const { openSnack, msg, severity } = msgState
    const handleClose = (event, reason) => {
        setMsgState({ ...msgState, openSnack: false })
    }

    const [columnState, setColumnState] = useState({});

    const handleColumnResize = (params) => {

        const newWidths = {
            ...columnState,
            [params.colDef.field]: params.width,
        };
        setColumnState(newWidths);
       
        saveSettings(newWidths, sortModel, selectedCols)
    };

    useEffect(() => {
        console.log("Column state=", columnState, selectedCols, sortModel)

    }, [columnState, selectedCols, sortModel])


    //polling or live chart update handler
    useEffect(() => {
        //set the ref to current state
        stateRef.current = state;

        const refreshInterval = setInterval(() => {

            if (selectedWatchList && stateRef.current.isPollingAllowed) {
                console.log("Calling polling notigication api")
                executeAPI(`${URL.GET_WATCHLIST}?name=${selectedWatchList}&mdata=1`, "GET", { mdata: 1, selectedWatchList })
            }

        }, stateRef.current.refreshInterval);

        return () => {
            clearInterval(refreshInterval);
        };
    }, [state]);


    useEffect(() => {
        const saved = sessionStorage.getItem(WATCHLIST_TABLE_SETTINGS_KEY);
        console.log("Session data=", saved)
        if (saved) {
            const parsed = JSON.parse(saved);
            setColumnState(parsed.columnWidths || {});
            setSortModel(parsed.sortModel || []);
            setSelectedCols(parsed.selectedCols || []);
        } else {
            //   setColumnWidths(defaultColumnWidths);
            setSortModel(defaultSortModel);
        }
        let data = {
            "symbol": "NIFTY",
            "watchlist_instruments": 1,
            "additional_instruments": props.symbolList
        }
        executeAPIUIData(URL.MPCHART_UIDATA, "POST", data);
    }, [])

    useEffect(() => {
        if (loadedUIData) {
            // console.log("Require auth:loaded user settings ========>",responseData);
            if (responseDataUIData != null) {
                responseDataUIData.wl_instruments = responseDataUIData.wl_instruments.map((item) =>
                    transformAndReverseMap(item)
                );
                // const filteredData = responseDataUIData.instruments.filter(item => item.of == true)
                const filteredData = responseDataUIData.wl_instruments;
                console.log("filteredData watchlist length", filteredData.length)
                setInstrumentData(filteredData)

                // localStorage.setItem('UIData', JSON.stringify(responseDataUIData));



            } else if (errorUIData !== null) {

            }
            if (pendingSymbol) {
                const found = responseDataUIData?.wl_instruments?.find(it => (it.symbol ?? it.instr) === pendingSymbol || it.instr === pendingSymbol);
                if (found) {
                    // now safe to navigate
                    props.reloadWithSymbol({symbol: pendingSymbol});
                    setPendingSymbol(null);
                }
            }
        }

    }, [loadedUIData, responseDataUIData])

    const columns = useMemo(
        () => columnList.filter((col) => selectedCols.includes(col.field)),
        [selectedCols, columnList]
    );

    const menuColumns = useMemo(
        () => columnList.filter((col) => !['displayName', 'actions'].includes(col.field)),
        [columnList]
    );

    useEffect(() => {
        if (dragging) {
            const handleMouseMove = (e) => {
                if (dragging) {
                    const delta = e.clientY - dragStartY;
                    setDividerY(startDividerY + delta);
                }
            };

            const handleMouseUp = () => {
                setDragging(false);
            };

            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);

            return () => {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [dragging]);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const toggleColumn = (field) => {

        const newCols = selectedCols.includes(field)
            ? selectedCols.filter((f) => f !== field)
            : [...selectedCols, field];

        setSelectedCols(newCols);
      
        saveSettings(columnState, sortModel, newCols);

    };

    const handleMouseDown = (e) => {
        setDragStartY(e.clientY);
        setStartDividerY(dividerY);
        setDragging(true);
    };


    const handleAddInstrument = () => {
        setInstrumentModal(true);
    }

    const watchListChangehandler = (name, list) => {
        if (name) {
            console.log("Watchlist mdata name=", name, list)
            setSelectedWatchlist(name);
            setSelectedWatchlistInstrument(list);
            executeAPI(`${URL.GET_WATCHLIST}?name=${name}&mdata=1`, "GET", { mdata: 1, name: name })
        } else {
            setSelectedWatchlist();
            setSelectedWatchlistInstrument([]);
            setColumnList([]);
            setTableData([]);
            setSelectedRow(null);

        }
    }

    const handleDelete = (deletedRow, list = selectedWatchListInstrument) => {
        // setRows((prev) => prev.filter((row) => row.id !== id));
        console.log("Deleteclicked ", selectedWatchListInstrument, list, deletedRow);
        const updatedSymbols = list.filter(sym => sym !== deletedRow.symbol);
        console.log("Deleteclicked 1", updatedSymbols, list, deletedRow);
        if (selectedWatchList) {
            // setSelectedWatchlistInstrument(updatedSymbols);
            closeHandler(updatedSymbols, selectedWatchList)
        }
    };

    useEffect(() => {
        // const newList = tableData.map(r => r.symbol);
        // setSelectedWatchlistInstrument(newList);
    }, [tableData]);

    useEffect(() => {
        console.log("Deleteclicked selectedWatchListInstrument=", selectedWatchListInstrument)
    }, [selectedWatchListInstrument])
    useEffect(() => {
        if (loaded) {
            // console.log("Watch list mdata========>", responseData.data);
            if (responseData != null) {
                // setIsLoading(false);
                if (responseData.data) {

                    const floatFields = responseData.float_vals || [];
                    const numFields = responseData.num_vals || [];
                    const colorFields = responseData.color_vals || [];
                    const lsFields = responseData.ls_vals || [];

                    const locale = userSettings.data.number_format_locale;



                    //transform the metadata into list based on dynamic columns
                    let sampleRows = [];
                    let tempList = [];

                    // const selectedSymbols = responseData.data?.[selectedWatchList] || [];
                    // if (responseData.metadata) {
                    //     sampleRows = Object.entries(responseData.metadata)
                    //         .filter(([symbol]) => selectedSymbols.includes(symbol))
                    //         .map(([symbol, data], index) => {
                    //             const row = {
                    //                 id: index + 1,
                    //                 symbol,
                    //                 ...data,
                    //             };
                    //             tempList.push(symbol);

                    //             Object.entries(responseData.display_cols).forEach(([displayName, field]) => {
                    //                 let value = data[field] ?? null;

                    //                 // Check if isContract is true and field is in ls_vals, and data.ls exists and is not 0
                    //                 if (dataTypeContracts && responseData.ls_vals?.includes(field) && data.ls) {
                    //                     value = value !== null ? value / data.ls : null;
                    //                 }

                    //                 row[field] = value;
                    //             });

                    //             return row;
                    //         });
                    // }

                    //traversing from wathlist data instead of metadata
                    if (responseData.metadata && responseData.data?.[selectedWatchList]) {
                        const symbolsFromWatchlist = responseData.data[selectedWatchList];
                      
                        sampleRows = symbolsFromWatchlist
                          .filter((symbol) => responseData.metadata[symbol]) // ensure metadata exists
                          .map((symbol, index) => {
                            const data = responseData.metadata[symbol];
                            const row = {
                              id: index + 1,
                              symbol,
                              ...data,
                            };
                            tempList.push(symbol);
                      
                            Object.entries(responseData.display_cols).forEach(([displayName, field]) => {
                              let value = data[field] ?? null;
                      
                              // If it's a contract and ls is present and non-zero, divide
                              if (dataTypeContracts && responseData.ls_vals?.includes(field) && data.ls) {
                                value = value !== null ? (value / data.ls).toFixed() : null;
                              }
                      
                              row[field] = value;
                            });
                      
                            return row;
                          });
                      }
                      
                    setSelectedWatchlistInstrument(tempList);

                    const allColumns = [
                        ...Object.entries(responseData.display_cols).map(([headerName, field]) => {
                            const isFloat = floatFields.includes(field);
                            const isNumVal = numFields.includes(field);
                            const isColorField = colorFields.includes(field);

                            return {
                                field,
                                headerName,
                                headerAlign: 'center',
                                // width: 80,
                                width: headerName == "Symbol" ? 115 : 75,
                                align: headerName === "Symbol" ? "left" : "right",

                                renderCell: (params) => {
                                    let value = params.value;

                                    // Format float
                                    if (isFloat && value != null && value !== '') {
                                        value = parseFloat(value).toFixed(2);
                                    }

                                    // Format number with locale
                                    if (isNumVal && value != null && value !== '') {
                                        value = Number(value).toLocaleString(locale);
                                    }

                                    // Decide color if it's a colorField
                                    let color = 'inherit';
                                    if (isColorField) {
                                        const numericValue = parseFloat(params.value);
                                        color = numericValue >= 0 ? 'green' : numericValue < 0 ? 'red' : 'inherit';
                                    }

                                    return (
                                        <Tooltip title={headerName == "Symbol" ? value : ""} placement='left'>
                                            <span style={{ fontSize: '12px', color, fontWeight: '600' }}>
                                                {value}
                                            </span>
                                        </Tooltip>
                                    );
                                }
                            };
                        }),
                        {
                            field: 'actions',
                            headerName: '',
                            sortable: false,
                            filterable: false,
                            width: 30,
                            disableColumnMenu: true,
                            // pinned: 'right',
                            align: "right",
                            cellClassName: 'delete-column',
                            headerClassName: 'delete-column',
                            renderCell: (params) => (

                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(params.row, tempList)
                                    }
                                    }
                                    size="small"
                                    sx={{
                                        opacity: 0,
                                        transition: 'opacity 0.2s',
                                        '.MuiDataGrid-row:hover &': { opacity: 1 }, // show on hover
                                    }}
                                >
                                    <DeleteIcon fontSize="small" sx={{ color: "red" }} />
                                </IconButton>

                            ),
                        },
                    ];
                    console.log("Session data 1=", columnList, selectedCols, allColumns.map((col) => col.field))
                    if (selectedCols && selectedCols.length == 0) {
                        setSelectedCols(allColumns.map((col) => col.field))
                    }

                    setColumnList(allColumns);
                    setTableData(sampleRows);
                    console.log("SelectedRows=", selectedRow, sampleRows, rowSelectionModel)
                    if (selectedRow) {
                        const matchedObject = sampleRows.find(item => item.symbol === selectedRow.symbol);

                        if (matchedObject)
                            setSelectedRow(matchedObject);
                        else {
                            setRowSelectionModel([]);

                            setSelectedRow(null);
                        }

                    }
                    console.log("watchlist instrument in api call=", selectedWatchListInstrument);


                    let updateInterval = pollingInterval;
                    if (responseData.isPreOpenLive != undefined && responseData.isPreOpenLive) {
                        updateInterval = reloadInerval;
                    }
                    else if (responseData.isTradingSessionActive != undefined && responseData.isTradingSessionActive) {
                        updateInterval = MP_CHART_RELOAD_TIME.FAST_POLLING;
                    }
                    // else{
                    //     updateInterval = 5000;
                    // }
                    setState((prevState) => ({
                        ...prevState,
                        refreshInterval: updateInterval,
                        isPollingAllowed: true,
                        isTradingSessionActive: responseData.isTradingSessionActive,
                        isInstrumentLive: responseData.isInstrumentLive,
                        isLivePollingAllowed: responseData.isPreOpenLive,
                        isLoading: false
                    }));
                    console.log("Watchlist allcolumns=>", allColumns, sampleRows, updateInterval);
                }

            } else if (error !== null) {
                setState((prevState) => ({
                    ...prevState,
                    isLoading: false
                }));

                console.log("Error data=", error);


                // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    console.log("status received =", error?.response?.status)
                    navigate(from, { replace: true });
                } else {
                    setMsgState({ open: true, msg: error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`, severity: "info" });
                }
            }
            reset();

        }

    }, [loaded, responseData])

    const closeHandler = (instrumentList, watchlistName) => {
        console.log("handleclose watchlist=", instrumentList, watchlistName)

        // setInstrumentModal(false);
        if (selectedWatchList) {
            let data = {
                [selectedWatchList]: instrumentList
            }
            setState((prevState) => ({
                ...prevState,
                isPollingAllowed: false,
            }));
            executeAPICreate(URL.CREATE_WATCHLIST, "POST", data);
        }
    }

    useEffect(() => {
        if (loadedCreate) {
            // console.log("Require auth:loaded user settings ========>",responseData);
            if (responseDataCreate != null) {
                executeAPI(`${URL.GET_WATCHLIST}?name=${selectedWatchList}&mdata=1`, "GET", { mdata: 1, name: selectedWatchList })

            } else if (errorCreate !== null) {
                if (errorCreate?.response?.status === 401 || errorCreate?.response?.status === 403) {
                    console.log("status received =", errorCreate?.response?.status)
                    navigate(from, { replace: true });
                } else {
                    setMsgState({ open: true, msg: errorCreate?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`, severity: "info" });
                }
            }
        }

    }, [loadedCreate, responseDataCreate])

    const handleMouseMove = useCallback((e) => {
        if (!isResizing.current) return;
        const deltaX = e.clientX - startX.current;
        const newWidth = Math.min(Math.max(startWidth.current - deltaX, WATCHLIST_MIN_WIDTH), WATCHLIST_MAX_WIDTH);
        if (newWidth != width)
            setWidth(newWidth);
    }, []);

    useEffect(() => {
        props.onWidthChanged(width);
    }, [width])

    const handleMouseUp = useCallback(() => {
        isResizing.current = false;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    }, [handleMouseMove]);

    const handleMouseDownWdith = (e) => {
        isResizing.current = true;
        startX.current = e.clientX;
        startWidth.current = width;

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const saveSettings = (widths, sort, selectedCols) => {
        // console.log("Savesettings=",widths,sort,selectedCols)
        sessionStorage.setItem(
            WATCHLIST_TABLE_SETTINGS_KEY,
            JSON.stringify({ columnWidths: widths, sortModel: sort, selectedCols: selectedCols })
        );
    };

    const handleSortModelChange = (model) => {
        // console.log("Savesettings=3",sortModel)
        setSortModel(model && model.length>0?model:sortModel);
        saveSettings(columnState, model, selectedCols);
    };

    return (
        <Box
            sx={{
                flexGrow: 1,
                bgcolor: `${theme.palette.primaryTheme.shade02}`,
                borderLeft: '1px solid #ffffff',
                display: 'flex',
                flexDirection: 'column',
                width: `${width}px`,
                position: 'absolute',
                top: '48px',
                left: `calc(100% - ${width + 50}px)`,
                overflow: 'hidden',
                overflowY: 'auto',
                zIndex: 4,
                height: 'calc(100% - 48px)',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width,
                    minWidth: WATCHLIST_MIN_WIDTH,
                    maxWidth: WATCHLIST_MAX_WIDTH,
                    height: '100vh',
                    //   backgroundColor: 'black',
                }}
            >
                <Box
                    onMouseDown={handleMouseDownWdith}
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: '3px',
                        cursor: 'ew-resize',
                        zIndex: 10,
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: '#ccc',
                        },
                    }}
                />
                {/* <Box p={2}>Left resizable box</Box> */}


                <Box flex={1} p={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center', px: 2, pt: 1, justifyContent: 'space-between' }}>

                        <WatchlistDropdownComponent onChange={(name, list) => watchListChangehandler(name, list)}></WatchlistDropdownComponent>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Button disabled={!selectedWatchList} onClick={handleAddInstrument} size="small" sx={{ width: "34px", minWidth: "34px" }}>
                                <AddIcon />
                            </Button>

                            <Button onClick={handleMenuClick} size="small" sx={{ width: "34px", minWidth: "34px" }}>
                                <MoreVertIcon />
                            </Button>
                        </Box>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            {menuColumns.map((col) => (
                                <MenuItem key={col.field} onClick={() => toggleColumn(col.field)}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={selectedCols.includes(col.field)} />
                                        }
                                        label={col.headerName}
                                    />
                                </MenuItem>
                            ))}
                        </Menu>

                    </Box>

                    <Box sx={{ height: dividerY, overflowX: 'auto', width: `${width - 20}px` }}>
                        {instrumentData && instrumentData.length > 0 ?
                            <DataGrid
                                columns={columns.map((col) => ({
                                    ...col,
                                    width: columnState?.[col.field] || col.width, // override width from saved state
                                }))}
                                sortModel={sortModel}
                                onSortModelChange={(model)=>handleSortModelChange(model)}
                                onColumnWidthChange={handleColumnResize}
                                headerHeight={32}
                                pagination={false}
                                rows={tableData}
                                // columns={columns}
                                density='standard'
                                onRowClick={(params) => {
                                    setSelectedRow(params.row)
                                }}
                                onRowDoubleClick={(params) => {
                                    console.log("instrument doublec lick here", params, props)
                                    if(props.chartType === CHART_SCREEN_TYPE.FULL_CHART ){
                                        // On double-click: if the symbol is already in UIDATA navigate immediately;
                                        // otherwise request UIDATA with the new symbol and defer navigation until it returns.
                                        const exists = instrumentData?.some(
                                        (it) => (it.symbol ?? it.instr) === params.row.symbol || it.instr === params.row.symbol
                                        );
                                        if (!exists) {
                                            setPendingSymbol(params.row.symbol);
                                            executeAPIUIData(URL.MPCHART_UIDATA, "POST", {
                                                symbol: params.row.symbol,
                                                instruments: 1,
                                                additional_instruments: [params.row.symbol],
                                            });
                                        } else {
                                            props.reloadWithSymbol({symbol: params.row.symbol});
                                        }
                                        setSelectedRow(params.row);
                                        
                                    }
                                    else {
                                        alert("action not supported for multi-window mode");
                                    }
                                }}
                                getRowId={(row) => row.symbol}
                                onRowSelectionModelChange={(newSelection) => setRowSelectionModel(newSelection)}
                                hideFooter
                                rowHeight={30}
                                disableColumnSelector // optional: hides column selector UI
                                disableSelectionOnClick // disables selection on cell click
                                disableColumnMenu
                                sx={{
                                    // width:width-20,
                                    userSelect: 'none',
                                    '& .delete-column': {
                                        position: 'sticky',
                                        right: 0,
                                        // opacity:0.7,
                                        backgroundColor: 'transparent', // match grid background
                                        zIndex: 2,
                                    },
                                    '& .MuiDataGrid-cell': {
                                        paddingLeft: "4px",
                                        paddingRight: "2px",
                                    },
                                    '& .MuiDataGrid-cell.delete-column': {
                                        padding: 0,
                                    },
                                    '& .MuiDataGrid-columnHeaders .delete-column': {
                                        zIndex: 3,
                                    },
                                    '& .MuiDataGrid-row:hover .MuiIconButton-root': {
                                        opacity: 1,
                                    },
                                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                        outline: 'none',
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        minHeight: 40,
                                        maxHeight: 40,
                                    },
                                    '& .MuiDataGrid-columnHeader': {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        minHeight: 40,
                                        maxHeight: 40,
                                    },
                                    '& .MuiDataGrid-columnHeaderTitle': {
                                        // fontSize: '0.75rem', // optional: reduce font if needed
                                        lineHeight: '32px',
                                    },
                                }}
                            /> :
                            <></>
                        }
                    </Box>

                    <Divider
                        sx={{ height: '3px', cursor: 'row-resize', backgroundColor: '#ccc' }}
                        onMouseDown={handleMouseDown}
                    />

                    <Box sx={{ flexGrow: 1, p: 1, overflow: 'auto' }}>
                        {selectedRow ? (
                            <Paper sx={{ p: 2 }}>
                                <Typography variant="h6">{selectedRow.displayLongName}{" "} {selectedRow.series}</Typography>
                                <Typography variant="h5" mt={2}>
                                    {selectedRow.close ? selectedRow.close.toFixed(2) : selectedRow.close}
                                    <span
                                        style={{
                                            marginLeft: 8,
                                            color: selectedRow.change < 0 ? 'red' : 'green',
                                            fontWeight: 'bold',
                                            //   fontFamily: 'monospace',
                                            fontSize: 16
                                        }}
                                    >
                                        {(selectedRow.change ? selectedRow.change.toFixed(2) : selectedRow.change)}
                                    </span>

                                </Typography>

                                <Typography mt={1} color="text.secondary">
                                    • Market {isInstrumentLive ? 'open' : 'closed'}
                                </Typography>
                                <Typography mt={2}>
                                    Delta: {selectedRow.delta ? selectedRow.delta.toFixed(4) : 0}
                                    <br/>
                                    Gamma: {selectedRow.gamma ? selectedRow.gamma.toFixed(4) : 0}
                                </Typography>
                            </Paper>
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                Select a row to see details
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
            {instrumentModal ?
                <WatchlistSymbolModal onCancel={() => setInstrumentModal(false)} selectedWatchListInstrument={selectedWatchListInstrument} name={selectedWatchList} open={instrumentModal} onClose={(list, name) => closeHandler(list, name)} instrumentList={instrumentData} /> :
                <></>
            }

        </Box>
    );
};

export default Watchlist;


